<template>
  <div>
    <v-expansion-panels v-if="!loading && specificFolder.length > 0">
      <DragDiv
        :list="specificFolder"
        group="common-third-sub-folder-items"
        ghost-class="ghost"
        animation="200"
        style="width: 100%"
        draggable=".my-list-common-third-sub-folder-items"
        @change="ChangeOrder"
      >
        <v-expansion-panel
          v-for="(item, i) in specificFolder"
          :key="i"
          readonly
          class="my-list-common-third-sub-folder-items"
        >
          <v-expansion-panel-header hide-actions style="cursor: default">
            <div
              v-if="item.isDocument"
              class="d-flex justify-center"
              style="max-width: 20px; margin-top: -6px"
            >
              <v-checkbox
                class="mr-1"
                dense
                small
                v-model="item.selected"
                hide-details
                @click="addToDownloadList(item)"
              ></v-checkbox>
            </div>
            <span
              v-if="item.isDocument"
              style="margin-bottom: -4px; margin-left: 6px"
            >
              <v-icon class="pr-2" style="margin-top: -3px">
                mdi-file-document-outline
              </v-icon>
              <span class="font-weight-medium pt-2">{{ item.name }}</span>
            </span>
            <span v-else>
              <v-icon class="pr-2" style="margin-top: -3px">
                mdi-folder-outline
              </v-icon>
              <span class="font-weight-medium pt-2">{{ item.name }}</span>
            </span>
            <div
              :style="`display: flex; justify-content: flex-end; ${
                item.isDocument ? 'margin-right: 32px' : 'margin-right: 12px'
              }`"
            >
              <span>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                      small
                      depressed
                      color="primary"
                      v-if="
                        institution.userType < 3 || institution.userType == 8
                      "
                      @click.stop="
                        item.isDocument
                          ? editDocument(item)
                          : updateFolder(item)
                      "
                    >
                      <v-icon small color="#f5f5f5">mdi-pencil-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip v-if="item.isDocument" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                      small
                      depressed
                      color="primary"
                      @click.stop="getFile(item)"
                    >
                      <v-icon small color="#f5f5f5">mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>
                  <span>Abrir documento</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="ma-1"
                      small
                      depressed
                      color="#ff4f64"
                      v-if="
                        institution.userType < 3 || institution.userType == 8
                      "
                      @click.stop="
                        item.isDocument
                          ? deleteDocument(item)
                          : deleteFolder(item)
                      "
                    >
                      <v-icon small color="#f5f5f5"
                        >mdi-trash-can-outline</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </span>
            </div>
          </v-expansion-panel-header>
        </v-expansion-panel>
      </DragDiv>
    </v-expansion-panels>
    <div
      v-else-if="!loading && specificFolder.length === 0"
      class="text-center pa-4"
    >
      <span>Esta pasta está vazia</span>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'

export default {
  name: 'commonSecondSubFolder',
  props: {
    folder: Object,
  },
  data() {
    return {
      apiService: new ApiService(),
      specificFolder: [],
      filterListFolderWithDoc: {
        institutionId: null,
        page: 1,
        pageSize: 10,
      },
      loading: false,
      user: {},
      institution: {},
    }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.getSpecificFolder(this.folder)
  },

  methods: {
    async ChangeOrder(event) {
      console.log(event)
      if (event.moved) {
        const findItem = event.moved.element
        findItem.order = event.moved.newIndex

        if (findItem.filePath) await this.updateDocOrder(findItem)
        else await this.updateFolderOrder(findItem)
      }
    },

    async updateDocOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('CommonAreaDocument/change-order', model)
    },

    async updateFolderOrder(item) {
      const model = {
        entityId: item.id,
        order: item.order,
      }
      this.apiService.post('CommonAreaDocumentFolder/change-order', model)
    },

    async getSpecificFolder(folder) {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      this.filterListFolderWithDoc.institutionId = institutionId
      this.filterListFolderWithDoc.folderId = folder.id
      this.loading = true

      try {
        const response = await this.apiService.get(
          `CommonAreaDocumentFolder/list-with-doc`,
          this.filterListFolderWithDoc
        )
        this.specificFolder = response.content.data
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error('Erro ao carregar dados da pasta:', error)
      }
    },

    editDocument(item) {
      this.$emit('edit-document', item)
    },

    updateFolder(item) {
      this.$emit('update-folder', item)
    },

    getFile(item) {
      this.$emit('get-file', item)
    },

    validateDoc(item) {
      this.$emit('validate-doc', item)
    },

    deleteDocument(item) {
      this.$emit('delete-document', item)
    },

    deleteFolder(item) {
      this.$emit('delete-folder', item)
    },

    addToDownloadList(item) {
      this.$emit('add-to-download-list', item)
    },
  },
}
</script>

<style scoped>
.topper-espansion-title {
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  line-height: 14px;
  overflow-wrap: break-word;
  text-align: center;
}
.v-expansion-panel-header {
  padding-block: 8px !important;
}
</style>
